import React, { useState, useContext, useCallback } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import i18n from 'i18n';
import { size } from 'lodash';
import { setNewPassword } from 'actions/profile';
import SpatialNavigationWrapper from 'components/navigation/SpatialNavigationWrapper';
import useBackIf from 'hooks/useBackIf';
import { RestorePasswordContext } from './RestorePasswordContext';
import Header from '../common/Header';
import PasswordForm from '../common/PasswordForm';
import { hideModal, showModal } from 'actions/modal';
import { MODAL_TYPES } from 'constants/modal-types';

const i18nScope = 'authorizationRestorePasswordSetNewPage';
const SECTION_NAME = 'PASSWORD_INPUT';
const MIN_PASS_LENGTH = 4;

const AuthorizationRestorePasswordSetNewPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [passwordState, setPasswordState] = useState(null);
  const isRepeatStep = history.location.pathname.includes('repeat');
  const { contextState } = useContext(RestorePasswordContext);
  const { phone, otp, email, contractId, contractNumber, isSeveralContracts } = contextState;

  const validation = useCallback((value) => size(value) >= MIN_PASS_LENGTH, []);

  const onSubmit = useCallback(
    (password) => {
      if (!isRepeatStep) {
        setPasswordState(password);
        history.push('repeat');
      } else if (passwordState !== password) {
        const onModalBack = () => {
          dispatch(hideModal());
          SpatialNavigationWrapper.focus(`@${SECTION_NAME}`);
        };

        dispatch(
          showModal(MODAL_TYPES.INFO, {
            message: i18n.t(`${i18nScope}.passwordNotMatch`),
            onModalBack,
          }),
        );
      } else {
        const errorModal = { returnFocusTo: `@${SECTION_NAME}` };
        dispatch(
          setNewPassword({
            otp,
            password,
            phone,
            email,
            contractId,
            contractNumber,
            isSeveralContracts,
            errorModal,
          }),
        );
      }
    },
    [contractId, contractNumber, dispatch, email, history, isRepeatStep, isSeveralContracts, otp, passwordState, phone],
  );

  const description = i18n.t(`${i18nScope}.description.${!isRepeatStep ? 'base' : 'repeat'}`);

  useBackIf(!phone && !email);

  return (
    <>
      <Header title={i18n.t(`${i18nScope}.title`)} description={description} />
      <PasswordForm
        key={isRepeatStep ? 1 : 0}
        placeholder={i18n.t(`${i18nScope}.passwordPlaceholder`)}
        invalidMessage={i18n.t(`${i18nScope}.passwordInvalid`)}
        buttonLabel={i18n.t(`${i18nScope}.next`)}
        loginType={phone ? 'phone' : 'email'}
        withVisibleKeyboard={isRepeatStep}
        sectionName={SECTION_NAME}
        onSubmit={onSubmit}
        validation={validation}
      />
    </>
  );
};

export default AuthorizationRestorePasswordSetNewPage;
